import React from 'react'
import {
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Tooltip,
  Select,
} from '@material-ui/core'
import { Button } from 'sputnik-ui'

export const FirmwareVersionTab = ({
  device,
  selectedFirmwareUuid,
  styles,
  setSelectedFirmwareUuid,
  handleUpdateFirmware,
  loading,
  t,
}) => {
  const currentMajor = parseInt(device?.config?.versions?.swVersion, 10)
  const selectedFw = device?.available_sw_versions?.find(
    (fw) => fw.uuid === selectedFirmwareUuid
  )
  const selectedMajor = selectedFw ? parseInt(selectedFw.version, 10) : null
  const isMajorUpgrade = currentMajor === 6 && selectedMajor === 7
  return (
    <>
      <FormControl
        style={styles.field}
        disabled={!device?.available_sw_versions?.length}
      >
        <InputLabel htmlFor="firmware_version">
          {t('devices:params.choose_firmware_version', {
            defaultValue: t('devices:params.firmware_versions'),
          })}
        </InputLabel>
        <Select
          value={selectedFirmwareUuid}
          onChange={(e) => setSelectedFirmwareUuid(e.target.value)}
          inputProps={{
            name: 'firmware_version',
            id: 'firmware_version',
          }}
        >
          {device?.available_sw_versions?.map((fw) => (
            <MenuItem key={fw.uuid} value={fw.uuid}>
              <Tooltip title={fw.description || ''} placement="right">
                <span style={{ display: 'block', width: '100%' }}>
                  {fw.version} [{fw.tag}]
                </span>
              </Tooltip>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {!device?.available_sw_versions?.length && (
        <Typography color="textSecondary" style={styles.field}>
          {t('devices:params.no_firmware_available')}
        </Typography>
      )}
      {isMajorUpgrade && (
        <Typography color="error" style={styles.field}>
          {t('devices:params.firmware_major_upgrade_warning')}
        </Typography>
      )}
      <Button
        primary
        variant="contained"
        rounded
        style={{ marginLeft: 'auto', marginTop: '1rem' }}
        onClick={handleUpdateFirmware}
        disabled={loading || !selectedFirmwareUuid || isMajorUpgrade}
      >
        {t('devices:actions.update_firmware', {
          defaultValue: 'Обновить прошивку',
        })}
      </Button>
    </>
  )
}
